import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { Partnerships } from 'features/cabinet';

const PartnershipsPage: FC = () => {
  return (
    <>
      <CabinetTitlePage
        title={'Partnerships'}
      />
      <Partnerships />
    </>
  );
};

export default PartnershipsPage;
